import { render, staticRenderFns } from "./SingleInherited.vue?vue&type=template&id=1e8803b4&"
import script from "./SingleInherited.vue?vue&type=script&lang=js&"
export * from "./SingleInherited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports